module.exports = __webpack_public_path__ + "src/assets/games/9/50.jpg";